module.exports = __webpack_public_path__ + "static/media/CHW30300-FHW40300-feature.7625e978.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/CHW30300-FHW40300-feature.png
// module id = 1024
// module chunks = 0